import { Component, OnInit } from '@angular/core';
import { find } from 'lodash';
import { HTTPService, HelperService, DateService } from 'app/services';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-warranty-policy-terms',
  templateUrl: './warranty-policy-terms.component.html',
  styleUrls: ['./warranty-policy-terms.component.scss']
})
export class WarrantyPolicyTermsComponent implements OnInit {
  isLoading: boolean = false;
  warrantyDisclaimer: string = '';
  tireWarrantyPolicy: string = '';
  company: any = {};
  order: any = {};
  warrantiedTires: Array<any> = [];
  vehicle: any = {};
  pdfLogoType: string = '';
  customer: any = {};
  mileageOut: any = {};
  defaultMileageUnit: any;
  currentLang: string = 'en';
  companyLocalization: boolean = false;

  constructor(private httpService: HTTPService,
    public helperService: HelperService,
    private activatedRoute: ActivatedRoute,
    private dateService: DateService,
    private translate: TranslateService,
  ) { }
  ngOnInit(): void {
    const token: string = this.activatedRoute.snapshot.paramMap.get('appt_conf_token');
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    this.companyLocalization = this.activatedRoute.snapshot.queryParamMap.get('localization') === 'true';
    if (this.companyLocalization) {
      this.currentLang = this.activatedRoute.snapshot.queryParamMap.get('lang') || 'en';
    }
    this.translate.use(this.currentLang);
    if (token) {
      this.getEstimatesById(token);
    } else {
      if (id) {
        this.getEstimatesByEstimateId(id);
      }
    }

  }

  getEstimatesByEstimateId(id: any) {
    this.isLoading = true;
    let url = id;
    url += `?isShowPaymentDetails=true`;
    if (this.currentLang) {
      url += `&lang=${this.currentLang.toUpperCase()}`;
    }
    this.httpService.getEstimateByIdForTokenPreview(url).then(
      (res: any) => {
        this.setData(res);
      },
      (error) => {
        this.helperService.showToaster('error', error);
      }
    ).finally(() => {
      this.isLoading = false;
    });
  }

  getEstimatesById(data: any) {
    this.isLoading = true;
    this.httpService.getEstimateByIdCustomerTokenPreview(data, false, this.currentLang.toUpperCase()).then(
      (res: any) => {
        this.setData(res);
      },
      (error) => {
        this.helperService.showToaster('error', error);
      }
    ).finally(() => {
      this.isLoading = false;
    });;
  }

  setData(res: any) {
    this.company = res.company || {};

    const shop = res.shop;
    const appsettings = this.company?.appsettings;

    if (shop) {
      if (shop.pdfLogo) {
        this.company.logo = shop.pdfLogo;
        this.company.pdfLogo = shop.pdfLogo;
        this.pdfLogoType = shop?.appsettings?.pdfLogoFormatType;
      } else {
        this.company.logo = shop.logo;
        this.company.pdfLogo = shop.pdfLogo;
      }
    } else if (this.company.pdfLogo) {
      this.company.logo = this.company.pdfLogo;
      this.pdfLogoType = appsettings.pdfLogoFormatType;
    }

    if (appsettings) {
      this.defaultMileageUnit = appsettings.mileageMeasuringUnit;
    }


    this.order = res.estimate;
    this.warrantyDisclaimer = res?.warrantyDisclaimer?.contents || '';
    this.tireWarrantyPolicy = res?.tireWarrantyPolicy?.contents || '';
    this.customer = res.estimate.customer;
    this.warrantiedTires = res?.warrantiedTires?.map((tire) => {
      const sizeObj = this.helperService.tireSizeParser(tire.size);
      if (sizeObj.tireSize && sizeObj.tireWidth && sizeObj.tireProfile) {
        tire.size = `${sizeObj.tireWidth} ${sizeObj.tireProfile} R${sizeObj.tireSize}`;
      }
      return tire;
    }) || [];
    this.vehicle = res.estimate?.vehicle?.vehicleId || {};
    if (this.warrantyDisclaimer) {
      this.warrantyDisclaimer = this.warrantyDisclaimer.replace(/\n/g, '<br>');
    }

    if (this.tireWarrantyPolicy) {
      this.tireWarrantyPolicy = this.tireWarrantyPolicy.replace(/\n/g, '<br>');
    }

    if (this.vehicle) {
      this.vehicle.name = this.helperService.trimString(this.vehicle.name);
      this.vehicle.vehicleName = this.helperService.trimString(this.vehicle.vehicleName);
    }

    if (this.order.createdAt) {
      this.order.createdAt = this.dateService.getCurrentDateTimeTz(new Date(this.order.backdatedCreationDate || this.order.createdAt).getTime(), res.company.timezone);
    }



    if (this.customer?.customerId?.address) {
      const { addLine1 = '', city = '', stateCode = '', zip = '', country = '' } = this.customer.customerId.address;
      const addressArr = [addLine1, city, stateCode];

      if (addLine1 || city || stateCode || zip) {
        addressArr.push(country || '');
      }

      addressArr.push(zip || '');

      this.customer.address = addressArr.filter((str) => !!str).join(', ');
    }

    if (this.company?.address) {
      const { addLine1 = '', city = '', stateCode = '', country = '', zip = '' } = this.company.address;
      const addressArr = [addLine1, city, stateCode, country, zip];
      this.company.formattedAdress = addressArr.filter((str) => !!str).join(', ');
    }

    if (this.order?.vehicleMileage?.reading && this.order?.vehicleMileage?.mileageMeasuringUnit) {
      this.mileageOut = {
        reading: this.order.vehicleMileage.reading,
        mileageMeasuringUnit: this.order.vehicleMileage.mileageMeasuringUnit,
      };
    }

    if (appsettings?.isMultiLocationEnabled && shop) {
      const shopDetailsKey = ['name', 'logo', 'email', 'phone'];

      shopDetailsKey.forEach((key: string) => {
        if (shop[key]) {
          this.company[key] = shop[key];
        }
      });

      if (shop.pdfLogo) {
        this.company.logo = shop.pdfLogo;
        this.company.pdfLogo = shop.pdfLogo;
        this.pdfLogoType = shop?.appsettings?.pdfLogoFormatType;
      } else {
        this.company.logo = shop.logo;
        this.company.pdfLogo = shop.pdfLogo;
      }

      if (shop.address?.addLine1) {
        const { addLine1 = '', city = '', stateCode = '', country = '', zip = '' } = shop.address;
        const addressArr = [addLine1, city, stateCode, country, zip];

        this.company.formattedAdress = addressArr.filter((str) => !!str).join(', ');
      }

    }
    this.isLoading = false;
  }

}